import React, { FC, ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { Money as MoneyModel } from 'api-client';
import { Money, Tooltip } from 'components/common/utils';
import { cn, declOfNum, RouteDictionary } from 'utils';

import styles from './MyMoneyV2.module.scss';

export type PortfolioMoneyItem = {
  id: string;
  label: string;
  money: MoneyModel;
  tooltip: string;
  accent?: boolean;
};

export type PortfolioRateItem = {
  id: string;
  label: string;
  value: ReactNode;
  tooltip: string;
};

type Props = {
  title: string;
  projects: number;
  moneyItems: PortfolioMoneyItem[];
  rateItems: PortfolioRateItem[];
  className?: string;
};

export const MyMoneyPortfolioCard: FC<Props> = ({
  title,
  projects,
  moneyItems,
  rateItems,
  className,
}) => (
  <section className={cn(styles.card, styles.portfolioCard, className)}>
    <div className={styles.portfolioHead}>
      <h3 className={styles.cardTitle}>{title}</h3>
      <Link to={`/dashboard/${RouteDictionary.MY_PROJECTS}`} className={styles.portfolioLink}>
        {projects} {declOfNum(projects, ['проект', 'проекта', 'проектов'])}
      </Link>
    </div>

    <div className={styles.portfolioMoneyGrid}>
      {moneyItems.map((item) => (
        <div key={item.id} className={styles.portfolioMoneyItem}>
          <div className={cn(styles.portfolioMoneyValue, item.accent && styles.portfolioAccent)}>
            <Money money={item.money} withPennies={false} />
          </div>
          <Tooltip content={item.tooltip}>
            <span className={styles.portfolioLabel}>{item.label}</span>
          </Tooltip>
        </div>
      ))}
    </div>

    <div className={styles.portfolioRateGrid}>
      {rateItems.map((item) => (
        <div key={item.id} className={styles.portfolioRateItem}>
          <div className={styles.portfolioRateValue}>{item.value}</div>
          <Tooltip content={item.tooltip}>
            <span className={styles.portfolioLabel}>{item.label}</span>
          </Tooltip>
        </div>
      ))}
    </div>
  </section>
);
